
import {Environment, EnvironmentEnum, SandboxEnvArr} from './env';

const Config = {
  Common:{
    ApiBaseUrl: "http://localhost:3045",
    ApiBaseSocket: "ws://localhost:3045",
    ApiSandboxBaseUrl: "http://localhost:3046",
    ApiSandboxBaseSocket: "ws://localhost:3046",
    AppName: "dawicoin",
    Company: "dawicoin",
    CompanyLink: "https://dawicoin.com/",
    FrontEndUrl: "http://localhost:3040",
    LiveFrontEndUrl: "http://localhost:3040",
    SandboxFrontEndUrl: "http://localhost:3041",
    ApiDocsUrl: "http://localhost:3044",
    SupportEmailName: "mail",
    SupportEmailDomain: "dawicoin.com",
  },
  Keys:{
    StripePublicKey: "",
    StripeAnnualPriceId: "",
    StripeMonthlyPriceId: "",
    GoogleAnalytics: "",
    RecaptchaPubKey: "6Lf6fvccAAAAAL0eCyCXdJgXz4OVrsiKvPROqRzS",
  },
  Sandbox: false,
};


if(SandboxEnvArr.indexOf(Environment) !== -1){
  Config.Sandbox = true;
}

if(Environment === EnvironmentEnum.LocalSandbox){
  Config.Common.ApiBaseUrl = Config.Common.ApiSandboxBaseUrl;
  Config.Common.ApiBaseSocket = Config.Common.ApiSandboxBaseSocket;
  Config.Common.FrontEndUrl = Config.Common.SandboxFrontEndUrl;
}

if(Environment === EnvironmentEnum.Release || Environment === EnvironmentEnum.ReleaseSandbox){
  Config.Common.LiveFrontEndUrl = "https://asurcoin.com";
  Config.Common.ApiDocsUrl = "https://docs.asurcoin.com";
  Config.Common.FrontEndUrl = Config.Common.SandboxFrontEndUrl;
}

if(Environment === EnvironmentEnum.Release){
  Config.Common.ApiBaseUrl = "https://api.asurcoin.com";
  Config.Common.ApiBaseSocket = "wss://api.asurcoin.com";
  Config.Common.FrontEndUrl = "https://asurcoin.com";
}

if(Environment === EnvironmentEnum.ReleaseSandbox){
  Config.Common.ApiBaseUrl = "https://api.sanbox.asurcoin.com";
  Config.Common.ApiBaseSocket = "wss://api.sanbox.asurcoin.com";
  Config.Common.SandboxFrontEndUrl = "https://sanbox.asurcoin.com";
}

if(Environment === EnvironmentEnum.Production || Environment === EnvironmentEnum.ProductionSandbox){
  Config.Common.LiveFrontEndUrl = "https://dawicoin.com";
  Config.Common.ApiDocsUrl = "https://docs.dawicoin.com";
  Config.Keys.RecaptchaPubKey = "6Le-ffccAAAAANhI5Fl-LYbbir38zx76HQdfKLmy";
  Config.Common.SandboxFrontEndUrl = "https://sanbox.dawicoin.com";
}

if(Environment === EnvironmentEnum.Production){
  Config.Common.ApiBaseUrl = "https://api.dawicoin.com";
  Config.Common.ApiBaseSocket = "wss://api.dawicoin.com";
  Config.Common.FrontEndUrl = "https://dawicoin.com";
}

if(Environment === EnvironmentEnum.ProductionSandbox){
  Config.Common.ApiBaseUrl = "https://api.sanbox.dawicoin.com";
  Config.Common.ApiBaseSocket = "wss://api.sanbox.dawicoin.com";
  Config.Common.FrontEndUrl = Config.Common.SandboxFrontEndUrl;
}

export default Config;
